export enum RegisterType {
  Manual = 'CB_TIGGER_MA',
  Automatic = 'CB_TIGGER_AU',
}
